import React, { useState, } from "react";
import { Modal, Button, Row, Col, Card, Form, Switch, Alert, } from 'antd';
import notification from '../../services/notification';
import { FormattedMessage, useIntl } from "react-intl";
import { ExportInvoices, } from '../../services/invoices';
import { Export, X, } from "@phosphor-icons/react";


const InvoiceExportModal = ({
    modalIsOpen,
    modalIsOpenHandler,
    history,

}) => {

    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const exportInvoices = JSON.parse(localStorage.getItem("exportInvoices") || '{}');
    const intl = useIntl();
    const onSubmit = () => {
        setButtonDisabled(true);
        setConfirmDelete(false);

        ExportInvoices({}, history)
            .then(response => {
                if (response.status) {
                    notification['success']({
                        message: 'Export',
                        description: intl.formatMessage({ id: response.msg }),
                    });

                    // set local storage to avoid running export again
                    localStorage.setItem("exportInvoices", JSON.stringify({ 'run': new Date().getHours() }));

                } else {
                    notification['error']({
                        message: 'Export',
                        description: intl.formatMessage({ id: response.msg }),
                    });
                }
                modalIsOpenHandler(false);
            })
            .catch(error => {
                console.error('error: ', error);
                setButtonDisabled(false);
            });
    };

    return (

        <Modal
            open={modalIsOpen}
            title={<><Export size={18} weight="light" /> <FormattedMessage id="export-invoices" /></>}
            onCancel={() => modalIsOpenHandler(false)}
            width={750}
            footer={[
                <Button key="1" onClick={() => modalIsOpenHandler(false)}
                    icon={<X size={16} />}>
                    <FormattedMessage id="cancel" />
                </Button>,
                <Button key="2"
                    type="primary"
                    hidden={exportInvoices.run === new Date().getHours()}
                    loading={buttonDisabled}
                    disabled={!confirmDelete}
                    onClick={onSubmit}>
                    {!buttonDisabled && (<Export size={16} weight="light" className="mr-1" />)} <FormattedMessage id="start-export" /></Button>,
            ]}>

            <Card sizee="small"
                style={{ minHeight: 300 }}
            >

                <Row>
                    <Col span={24} className="py-4">
                        <h3><FormattedMessage id="export-invoices-info" /></h3>
                    </Col>

                    {exportInvoices.run === new Date().getHours() ? (
                        <Col span={24} className="py-4">
                            <Alert
                                title={<FormattedMessage id="export-common-blocked" />}
                                description={<FormattedMessage id="export-common-blocked-info" />}
                                type="warning" showIcon />
                        </Col>
                    ) : (
                        <>
                            <Col span={24}>
                                <FormattedMessage id="export-common-description" />
                            </Col>

                            <Form.Item
                                label={<FormattedMessage id="export-common-confirm" />}
                                className="py-2">
                                <Switch
                                    checked={confirmDelete}
                                    onChange={e => setConfirmDelete(!confirmDelete)}
                                />
                            </Form.Item>
                        </>
                    )}

                </Row>
            </Card>
        </Modal>
    );
};


export default InvoiceExportModal;
